export default {
    intro: '소리를 듣고, 올바르게 적어보세요!',
    wordIndex: '{index} 번째 단어',
    student: {
        myAnswer: '내가 제출한 답안',
        noAnswer: '제출한 답안이 없습니다.',
        answer: '정답',
        attemptNumber: '{number}차',
        listen: '귀 기울여 들어보세요!<br />집중해서 들어주세요!',
        teacherReading: '선생님이 직접 읽어주고 있어요',
        listenDirect: '선생님이 직접 읽어주시는 문장을 잘 들어주세요!',
        placeholder: '정답을 입력해주세요.',
        wrongToast: '앗 틀렸어요. 다시 입력해보세요',
        writeEnd: '쓰기 종료',
        submitAnswer: '답안 제출',
        waitingStart: '선생님의 쓰기 시작 신호를 기다려주세요!',
        threeWrong: '3번의 정답 기회를 모두 소진했어요... 선생님이 정답을 공개해 주실 때까지 기다려주세요!',
    },
    teacher: {
        setting: {
            activity: '활동내용',
            number: '번호',
            title: '받아쓰기 📝',
            message: '지금 문장을 재생하면 학생들에게도 들릴 수 있어요!',
            subMessage: '그래도 재생할까요?',
            optionSubMessage: '한 번 재생한 이후에는 확인창이 다시 나오지 않습니다.',
            confirmText: '재생하기',
        },

        question: '문항',
        intro: '왼쪽 문항에서 단어를 선택해 주세요.',
        ttsStart: '재생 후 쓰기 시작',
        directReading: '직접 읽어주기',
        startWriting: '쓰기 시작',
        completeWriting: '쓰기 완료 및 정답 공개',
        toast: {
            alreadyDone: '이미 진행한 단어입니다.',
            fiveSeconds: '쓰기 시작후 5초후에 쓰기 완료 가능합니다.',
        },

        // 결과 페이지
        result: {
            title: '문항별 정답률',
            order: '순서',
            question: '문항',
            answerRate: '정답률',
        },
    },
    table: {
        question: '문제',
        answerRate: '정답률',
        emptyMessage: '내용이 없어요.',
    },
};
